import styled from "@emotion/styled";
import {  Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { FC } from "react";

interface ProductDescriptionFormProps {
  is_active: boolean;
}

const ProductDescriptionForm: FC<ProductDescriptionFormProps> = ({ is_active }) => {
  return (
 
    <FormWrapper>
      <Form.Item
        label="คำอธิบายสินค้า (Product)"
        name="description"
        rules={[{ required: is_active, message: "กรุณากรอกคำอธิบายสินค้า" }]}
        
      >
        <TextArea  placeholder="คำอธิบายสินค้า (Product) จุดเด่น คุณภาพ มาตรฐาน" showCount maxLength={5000}  rows={10} />
      </Form.Item>
    </FormWrapper>

  );
};

export default ProductDescriptionForm;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
`;
